// 4 seconds without sparkline
// 8.5 seconds with sparkline
export default (startTime, endTime, searchValue, queryFields, allFields) => {
  return {
    namespace: "/bq_summary",
    stale: 1,
    expire: 1,
    queryParams: [
      {
        refName: "startTime",
        field: "created",
        operator: "gt",
        value: startTime.utc().startOf("day").format("YYYY-MM-DDTHH:mm"),
      },
      {
        refName: "endTime",
        field: "created",
        operator: "lt",
        value: endTime.utc().endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS999"),
      },
      {
        field: "associationType",
        operator: "eq",
        negate: true,
        value: "",
      },
      [
        ...queryFields
          .filter((field) => !!field.validate(searchValue))
          .map((field) => {
            return {
              field: field.fieldName,
              operator: field.op,
              value: searchValue,
            };
          }),
      ],
    ],
    resultParams: {
      transform: [
        {
          field: "total",
          negate: false,
          operator: "sum",
          value: "sum_total",
        },
        {
          field: "bytes",
          negate: false,
          operator: "sum",
          value: "sum_bytes",
        },
        {
          field: "minTimestamp",
          negate: false,
          operator: "min",
          value: "fromTime",
        },
        {
          field: "minTimestamp",
          negate: false,
          operator: "max",
          value: "toTime",
        },
        {
          operator: "count",
          value: "grouped_count",
        },
        {
          field: "total",
          negate: false,
          operator: "histogram.min_timestamp.1d",
          value: "sparkline",
        },
      ],
      outputFields: [
        "sum_total",
        "sum_bytes",
        "logger",
        "associationType",
        ...allFields.map((f) => f.fieldName),
      ],
    },
  };
};
